let eraseDynanicObject = (e) => {
  let $dynamicContainer = $('#additionalLobbyist');
  let $children = $dynamicContainer.find('fieldset:visible');
  let n_children = $children.length;
  let $controllers = $children.find('.cta.float');
  let $card = $(e.target).closest('fieldset.card');

  let updatingVariables = () => {
    $children = $dynamicContainer.find('fieldset:visible');
    n_children = $children.length;
  };

  let onlyChild = () => {
    $children = $dynamicContainer.find('fieldset:visible');
    n_children = $children.length;

    let isOnlyChild = n_children < 2;
    if (isOnlyChild) {
      $controllers.hide();
    }
  };

  updatingVariables();

  $card.find('input[type=hidden].destroy-field').val('true');
  $card.hide();

  onlyChild();
};

$(document).on('click', '.destroy-nested-object', (e) => {
  eraseDynanicObject(e);
  $(document).trigger("fieldChange")
});